import React, { useEffect, useState } from "react";
import { Button, Accordion, Tabs, Tab } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";
import { authService } from "Service/Axios";
import { FORM_BUILDER_GLOBAL } from "Constant/api";

const FormLeftbar = ({ globalList, setGlobalList }) => {
  const handleGlobalList = async () => {
    const payload = {};
    const response = await authService(FORM_BUILDER_GLOBAL, "POST", payload);
    if (response) {
      setGlobalList(response);
    }
  };

  return (
    <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 h-100 global-tab">

      <ul className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
        <li className="nav-item" role="presentation">
          <button className="nav-link active" id="nav-elements-tab" data-bs-toggle="pill" data-bs-target="#nav-elements" type="button" role="tab" aria-controls="nav-elements" aria-selected="true" onClick={() => { }}>Elements</button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" id="nav-advance-tab" data-bs-toggle="pill" data-bs-target="#nav-advance" type="button" role="tab" aria-controls="nav-advance" aria-selected="false" onClick={() => { handleGlobalList() }}>Advance</button>
        </li>
      </ul>
      <div className="tab-content" id="nav-tabContent">
        <div className="tab-pane fade show active" id="nav-elements" role="tabpanel" aria-labelledby="nav-elements-tab" tabIndex="0">
          <div className="search-div mb-3">
            <div className="input-group">
              <span className="input-group-text">
                <i className="pluto-search"></i>
              </span>
              <input
                type="search"
                className="form-control"
                placeholder="Search element"
              />
            </div>
          </div>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Text Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="short" index={90} key={1}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          notes
                        </span>{" "}
                        Short text
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="long" index={91} key={2}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          subject
                        </span>{" "}
                        Long text
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="number" index={92} key={3}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          123
                        </span>{" "}
                        Number
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="description" index={93} key={4}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          description
                        </span>{" "}
                        Description
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="paragraph" index={120} key={20}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          subject
                        </span>{" "}
                        Paragraph
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Choice Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="toggle_on" index={94} key={5}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          toggle_on
                        </span>{" "}
                        Yes/No
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="drop_on" index={95} key={6}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          expand_more
                        </span>{" "}
                        Dropdown
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="check_on" index={96} key={7}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          priority
                        </span>{" "}
                        Checkbox
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="mutiple_on" index={97} key={8}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          radio_button_checked
                        </span>{" "}
                        Radio Button
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="auto_complete" index={100} key={17}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          fact_check
                        </span>{" "}
                        Auto Complete
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="multiinp" index={104} key={21}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          view_list
                        </span>{" "}
                        Multi Input Grid
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="multiChecks" index={106} key={23}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          view_list
                        </span>{" "}
                        Multi Checkbox
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Contact Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">

                  <Draggable draggableId="loc" index={110} key={27}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          location_on
                        </span>{" "}
                        Address
                      </div>
                    )}
                  </Draggable>

                  <Draggable draggableId="call" index={109} key={26}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          call
                        </span>{" "}
                        Phone No
                      </div>
                    )}
                  </Draggable>

                  <Draggable draggableId="web" index={108} key={25}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          link
                        </span>{" "}
                        Website
                      </div>
                    )}
                  </Draggable>

                  <Draggable draggableId="emails" index={54} key={15}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          alternate_email
                        </span>{" "}
                        Email
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Calender Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="dates" index={50} key={11}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          calendar_month
                        </span>{" "}
                        Date
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="times" index={51} key={12}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="align-middle bx bx-time"></span> Time
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Media Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="fileUp" index={98} key={9}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          upload
                        </span>{" "}
                        File Upload
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="fileDown" index={99} key={10}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          download
                        </span>{" "}
                        Download
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="video" index={101} key={18}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          videocam
                        </span>{" "}
                        Video Link
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="record" index={105} key={22}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          videocam
                        </span>{" "}
                        Video
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="image" index={102} key={19}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          image
                        </span>{" "}
                        Image
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>Layout Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="pgbreak" index={53} key={14}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="pluto-page-breaker"></span> Page
                        Breaker
                      </div>
                    )}
                  </Draggable>

                  <Draggable draggableId="sectn" index={52} key={13}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="pluto-section"></span> Section
                      </div>
                    )}
                  </Draggable>

                  <Draggable draggableId="confirms" index={55} key={16}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          priority
                        </span>{" "}
                        Confirmation
                      </div>
                    )}
                  </Draggable>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>Advance elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable draggableId="rate" index={103} key={20}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          star
                        </span>{" "}
                        Rating
                      </div>
                    )}
                  </Draggable>
                  <Draggable draggableId="signature" index={107} key={24}>
                    {(provided, snapshot) => (
                      <div
                        className="btn btn-gray-light btn-sm"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <span className="material-symbols-outlined align-middle">
                          signature
                        </span>{" "}
                        Signature
                      </div>
                    )}
                  </Draggable>
                  <Button variant="gray-light btn-sm">
                    <span className="material-symbols-outlined align-middle">
                      credit_card
                    </span>{" "}
                    Payment
                  </Button>
                  <Button variant="gray-light btn-sm">
                    <span className="bx bx-code-alt align-middle bx-sm"></span>{" "}
                    Embed Code
                  </Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="tab-pane fade" id="nav-advance" role="tabpanel" aria-labelledby="nav-advance-tab" tabIndex="0">
          <div className="search-div mb-3">
            <div className="input-group">
              <span className="input-group-text">
                <i className="pluto-search"></i>
              </span>
              <input
                type="search"
                className="form-control"
                placeholder="Advance Search"
              />
            </div>
          </div>
          <div className="d-flex flex-column row-gap-3 max-h-500 overflow-y-auto">
            {globalList?.map((item, index) => {
              return <Draggable draggableId={item.globalId} index={index} key={item.globalId}>
                {(provided, snapshot) => (
                  <div className="p-4 rounded border border-grey-200 bg-grey-100 d-flex flex-column row-gap-2" {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}>
                    <h4 className="text-sm font-medium text-grey-700">{item.label}</h4>
                    <div>{item.elementType == "short" ? <span className="material-symbols-outlined align-middle me-2">
                      notes
                    </span> : item.elementType == "long" ? <span className="material-symbols-outlined align-middle me-2">
                      subject
                    </span> : item.elementType == "paragraph" ? <span className="material-symbols-outlined align-middle me-2">
                      subject
                    </span> : item.elementType == "number" ? <span className="material-symbols-outlined align-middle bx-md me-2">
                      123
                    </span> : item.elementType == "description" ? <span className="material-symbols-outlined align-middle me-2">
                      description
                    </span>
                      : item.elementType == "drop_on" ? <span className="material-symbols-outlined align-middle me-2">
                        expand_more
                      </span> : item.elementType == "toggle_on" ? <span className="material-symbols-outlined align-middle me-2">
                        toggle_on
                      </span> : item.elementType == "check_on" ? <span className="material-symbols-outlined align-middle me-2">
                        checklist
                      </span> : item.elementType == "mutiple_on" ? <span className="material-symbols-outlined align-middle me-2">
                        radio_button_checked
                      </span> : item.elementType == "fileUp" ? <span className="material-symbols-outlined align-middle me-2">
                        upload
                      </span> : item.elementType == "fileDown" ? <span className="material-symbols-outlined align-middle me-2">
                        download
                      </span> : item.elementType == "dates" ? <span className="material-symbols-outlined align-middle me-2">
                        calendar_month
                      </span> : item.elementType == "times" ? <span className="align-middle bx bx-time me-2">
                      </span> : item.elementType == "emails" ? <span className="material-symbols-outlined align-middle me-2">
                        alternate_email
                      </span> : item.elementType == "confirms" ? <span className="material-symbols-outlined align-middle me-2">
                        priority
                      </span> : item.elementType == "auto_complete" ? <span className="material-symbols-outlined align-middle me-2">
                        fact_check
                      </span> : item.elementType == "video" ? <span className="material-symbols-outlined align-middle me-2">
                        videocam
                      </span> : item.elementType == "image" ? <span className="material-symbols-outlined align-middle me-2">
                        image
                      </span> : item.elementType == "rate" ? <span className="material-symbols-outlined align-middle me-2">
                        star
                      </span> : item.elementType == "multiinp" ? <span className="material-symbols-outlined align-middle me-2">
                        view_list
                      </span> : item.elementType == "sectn" ? <span className="material-symbols-outlined align-middle me-2 pluto-section"></span> : <span className="material-symbols-outlined align-middle me-2 pluto-section"></span>}{" "}
                      {item.elementType == "short" ? "Short text" : item.elementType == "long" ? "Long Text" : item.elementType == "paragraph" ? "Paragraph" : item.elementType == "number" ? "Number" : item.elementType == "description" ? "Description" : item.elementType == "drop_on" ? "Dropdown" : item.elementType == "toggle_on" ? "Yes / No" : item.elementType == "check_on" ? "Checkbox" : item.elementType == "mutiple_on" ? "Radio Button" : item.elementType == "fileUp" ? "File Upload" : item.elementType == "fileDown" ? "File Download" : item.elementType == "dates" ? "Date" : item.elementType == "times" ? "Time" : item.elementType == "emails" ? "Email" : item.elementType == "confirms" ? "Confirmation" : item.elementType == "auto_complete" ? "Auto Complete" : item.elementType == "video" ? "Video" : item.elementType == "image" ? "Image" : item.elementType == "rate" ? "Rating" : item.elementType == "multiinp" ? "Multi Input Grid" : item.elementType == "sectn" ? "Section" : "Page Breaker"}</div>
                    <div className="d-flex flex-column row-gap-3">
                      {item?.questions?.map((item, index) => {
                        return <div className="drag-cursor text-xs text-grey-600 d-flex align-items-center gap-2">
                          {item.elementType == "short" ? <span className="material-symbols-outlined align-middle me-2">
                            notes
                          </span> : item.elementType == "long" ? <span className="material-symbols-outlined align-middle me-2">
                            subject
                          </span> : item.elementType == "paragraph" ? <span className="material-symbols-outlined align-middle me-2">
                            subject
                          </span> : item.elementType == "number" ? <span className="material-symbols-outlined align-middle bx-md me-2">
                            123
                          </span> : item.elementType == "description" ? <span className="material-symbols-outlined align-middle me-2">
                            description
                          </span>
                            : item.elementType == "drop_on" ? <span className="material-symbols-outlined align-middle me-2">
                              expand_more
                            </span> : item.elementType == "toggle_on" ? <span className="material-symbols-outlined align-middle me-2">
                              toggle_on
                            </span> : item.elementType == "check_on" ? <span className="material-symbols-outlined align-middle me-2">
                              checklist
                            </span> : item.elementType == "mutiple_on" ? <span className="material-symbols-outlined align-middle me-2">
                              radio_button_checked
                            </span> : item.elementType == "fileUp" ? <span className="material-symbols-outlined align-middle me-2">
                              upload
                            </span> : item.elementType == "fileDown" ? <span className="material-symbols-outlined align-middle me-2">
                              download
                            </span> : item.elementType == "dates" ? <span className="material-symbols-outlined align-middle me-2">
                              calendar_month
                            </span> : item.elementType == "times" ? <span className="align-middle bx bx-time me-2">
                            </span> : item.elementType == "emails" ? <span className="material-symbols-outlined align-middle me-2">
                              alternate_email
                            </span> : item.elementType == "confirms" ? <span className="material-symbols-outlined align-middle me-2">
                              priority
                            </span> : item.elementType == "auto_complete" ? <span className="material-symbols-outlined align-middle me-2">
                              fact_check
                            </span> : item.elementType == "video" ? <span className="material-symbols-outlined align-middle me-2">
                              videocam
                            </span> : item.elementType == "image" ? <span className="material-symbols-outlined align-middle me-2">
                              image
                            </span> : item.elementType == "rate" ? <span className="material-symbols-outlined align-middle me-2">
                              star
                            </span> : item.elementType == "multiinp" ? <span className="material-symbols-outlined align-middle me-2">
                              view_list
                            </span> : item.elementType == "sectn" ? <span className="material-symbols-outlined align-middle me-2 pluto-section"></span> : <span className="material-symbols-outlined align-middle me-2 pluto-section"></span>}<span className="line-clamp-1 d-block">{item.label}</span>{" "}
                          {item.elementType == "short" ? "Short text" : item.elementType == "long" ? "Long Text" : item.elementType == "paragraph" ? "Paragraph" : item.elementType == "number" ? "Number" : item.elementType == "description" ? "Description" : item.elementType == "drop_on" ? "Dropdown" : item.elementType == "toggle_on" ? "Yes / No" : item.elementType == "check_on" ? "Checkbox" : item.elementType == "mutiple_on" ? "Radio Button" : item.elementType == "fileUp" ? "File Upload" : item.elementType == "fileDown" ? "File Download" : item.elementType == "dates" ? "Date" : item.elementType == "times" ? "Time" : item.elementType == "emails" ? "Email" : item.elementType == "confirms" ? "Confirmation" : item.elementType == "auto_complete" ? "Auto Complete" : item.elementType == "video" ? "Video" : item.elementType == "image" ? "Image" : item.elementType == "rate" ? "Rating" : item.elementType == "multiinp" ? "Multi Input Grid" : item.elementType == "sectn" ? "Section" : "Page Breaker"}
                        </div>
                      })}
                    </div>
                  </div>
                )}
              </Draggable>
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLeftbar;
